import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';
import * as React from 'react';
import { updateBeginingDate, updateEndDate } from "../../features/uidata/uidataSlice";
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import {
  selectQueryDate
} from '../../features/uidata/uidataSlice';

import CustomDatePicker from './CustomDatePicker';
import MenuButton from './MenuButton';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import Search from './Search';
export default function Header() {
  //const { beginingDate, endDate } = useSelector(selectQueryDate);
  const beginingDate = useSelector(
    state => state.uidata.beginingDate
  );
  const endDate = useSelector(
    state => state.uidata.endDate
  );
  const validate = (d, start) => {    
    const beginingDateTemp = start ? d : new Date(beginingDate);
    const endDateTemp = start ? new Date(endDate) : d;
    if (beginingDateTemp.getTime() > endDateTemp.getTime()) {
      return false;
    }
    return true;
  }
  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <NavbarBreadcrumbs />
      <Stack direction="row" sx={{ gap: 4 }}>
        {/* <Search /> */}
        {/* <CustomDatePicker start={true} onChangeCallback={updateBeginingDate} date={beginingDate} validate={validate} />
        <CustomDatePicker start={false} onChangeCallback={updateEndDate} date={endDate} validate={validate} />
        <MenuButton showBadge aria-label="Open notifications">
          <NotificationsRoundedIcon />
        </MenuButton> */}
        <ColorModeIconDropdown />
      </Stack>
    </Stack>
  );
}
